var Size = function () {
  function Size(width, height) {
    this.width = width;
    this.height = height;
  }

  return Size;
}();

export { Size };